import {
  filterItemBasicCheckElementTypes,
  filterItemBasicDesigns,
  filterItemBasicDirections
} from '@adv-mt/mt-filter-item-basic'

import FilterBasicButtonGroup from './components/ButtonGroup/index.js'
import FilterBasicDefault from './components/Default/index.js'
import FilterBasicInputNumber from './components/InputNumber/index.js'
import FilterBasicMultiSelectionNested from './components/MultiSelectionNested/index.js'
import FilterBasicTagGroup from './components/TagGroup/index.js'

const {CHECKBOX, IMAGE, RADIO_BUTTON} = filterItemBasicCheckElementTypes
const {COLUMN_REVERSE} = filterItemBasicDirections
const {FLAT_OUTLINED, OUTLINED, ROUNDED_OUTLINED} = filterItemBasicDesigns

export const BASE_CLASS_NAME = 'mt-FilterBasic'
export const LABEL_CLASS_NAME = `${BASE_CLASS_NAME}-label`
export const LIST_CLASS_NAME = `${BASE_CLASS_NAME}-list`
export const LIST_ITEM_CLASS_NAME = `${LIST_CLASS_NAME}Item`
export const LIST_ITEM_STICKY_CLASS_NAME = `${LIST_ITEM_CLASS_NAME}--sticky`

export const NO_OP = () => {}

export const DESIGNS = {
  GRID: 'grid',
  GRID_COLUMN: 'gridColumn',
  HIGHLIGHTED: 'highlighted',
  WITH_BORDER: 'withBorder'
}

export const LIST_DIRECTIONS = {
  ROW: 'row',
  ROW_ROUNDED: 'rowRounded'
}

export const TYPES = {
  BUTTON_GROUP_MULTI_SELECTION: 'buttonGroupMultiSelection',
  INPUT_NUMBER: 'inputNumber',
  BUTTON_GROUP_SINGLE_SELECTION_GRID: 'buttonGroupSingleSelectionGrid',
  BUTTON_GROUP_SINGLE_SELECTION: 'buttonGroupSingleSelection',
  CHECKBOX_GROUP_MULTI_SELECTION: 'checkboxGroupMultiSelection',
  CHECKBOX_GROUP_SINGLE_SELECTION_DETAILED_WITH_BORDER: 'checkboxGroupSingleSelectionDetailedWithBorder',
  CHECKBOX_GROUP_SINGLE_SELECTION_WITH_BORDER: 'checkboxGroupSingleSelectionWithBorder',
  CHECKBOX_GROUP_SINGLE_SELECTION: 'checkboxGroupSingleSelection',
  IMAGE_MULTI_SELECTION_GRID_COLUMN_WITH_BORDER: 'imageMultiSelectionGridColumnWithBorder',
  IMAGE_MULTI_SELECTION_GRID_COLUMN: 'imageMultiSelectionGridColumn',
  IMAGE_MULTI_SELECTION_WITH_BORDER_ROW_SCROLLABLE: 'imageMultiSelectionWithBorderRowScrollable',
  IMAGE_MULTI_SELECTION: 'imageMultiSelection',
  IMAGE_SINGLE_SELECTION_GRID_COLUMN_WITH_BORDER: 'imageSingleSelectionGridColumnWithBorder',
  IMAGE_SINGLE_SELECTION_WITH_BORDER_ROW_SCROLLABLE: 'imageSingleSelectionWithBorderRowScrollable',
  IMAGE_SINGLE_SELECTION_WITH_BORDER: 'imageSingleSelectionWithBorder',
  IMAGE_SINGLE_SELECTION: 'imageSingleSelection',
  MULTI_SELECTION_NESTED: 'multiSelectionNested',
  MULTI_SELECTION_OUTLINED: 'multiSelectionOutlined',
  MULTI_SELECTION_ROUNDED_OUTLINED: 'multiSelectionRoundedOutlined',
  MULTI_SELECTION_ROUNDED_OUTLINED_WITHOUT_ICON_CHECK: 'multiSelectionRoundedOutlinedWithoutIconCheck',
  MULTI_SELECTION: 'multiSelection',
  RADIO_BUTTON_GROUP_MULTI_SELECTION: 'radioButtonGroupMultiSelection',
  RADIO_BUTTON_GROUP_SINGLE_SELECTION: 'radioButtonGroupSingleSelection',
  SINGLE_SELECTION_OUTLINED: 'singleSelectionOutlined',
  SINGLE_SELECTION: 'singleSelection',
  TAG_GROUP_SINGLE_SELECTION_GRID: 'tagGroupSingleSelection'
}

export const COMPONENTS = {
  [TYPES.INPUT_NUMBER]: <FilterBasicInputNumber />,
  [TYPES.BUTTON_GROUP_MULTI_SELECTION]: <FilterBasicButtonGroup isMultiSelect />,
  [TYPES.BUTTON_GROUP_SINGLE_SELECTION]: <FilterBasicButtonGroup />,
  [TYPES.BUTTON_GROUP_SINGLE_SELECTION_GRID]: <FilterBasicButtonGroup design={DESIGNS.GRID} />,
  [TYPES.TAG_GROUP_SINGLE_SELECTION_GRID]: <FilterBasicTagGroup />,
  [TYPES.CHECKBOX_GROUP_MULTI_SELECTION]: <FilterBasicDefault checkElementType={CHECKBOX} isMultiSelect />,
  [TYPES.CHECKBOX_GROUP_SINGLE_SELECTION]: <FilterBasicDefault checkElementType={CHECKBOX} />,
  [TYPES.CHECKBOX_GROUP_SINGLE_SELECTION_WITH_BORDER]: (
    <FilterBasicDefault checkElementType={CHECKBOX} design={DESIGNS.WITH_BORDER} />
  ),
  [TYPES.CHECKBOX_GROUP_SINGLE_SELECTION_DETAILED_WITH_BORDER]: (
    <FilterBasicDefault checkElementType={CHECKBOX} design={DESIGNS.WITH_BORDER} />
  ),
  [TYPES.IMAGE_SINGLE_SELECTION]: (
    <FilterBasicDefault
      checkElementType={IMAGE}
      isFullWidth={false}
      listDirection={LIST_DIRECTIONS.ROW}
      listItemDirection={COLUMN_REVERSE}
    />
  ),
  [TYPES.IMAGE_SINGLE_SELECTION_WITH_BORDER]: (
    <FilterBasicDefault
      checkElementType={IMAGE}
      isFullWidth={false}
      listDirection={LIST_DIRECTIONS.ROW}
      listItemDirection={COLUMN_REVERSE}
      listItemsDesign={FLAT_OUTLINED}
    />
  ),
  [TYPES.IMAGE_SINGLE_SELECTION_GRID_COLUMN_WITH_BORDER]: (
    <FilterBasicDefault
      checkElementType={IMAGE}
      isFullWidth={false}
      listDesign={DESIGNS.GRID_COLUMN}
      listDirection={LIST_DIRECTIONS.ROW}
      listItemDirection={COLUMN_REVERSE}
      listItemsDesign={FLAT_OUTLINED}
    />
  ),
  [TYPES.IMAGE_SINGLE_SELECTION_WITH_BORDER_ROW_SCROLLABLE]: (
    <FilterBasicDefault
      checkElementType={IMAGE}
      design={DESIGNS.WITH_BORDER}
      isFullWidth={false}
      isScrollable
      listDirection={LIST_DIRECTIONS.ROW}
      listItemDirection={COLUMN_REVERSE}
      listItemsDesign={FLAT_OUTLINED}
    />
  ),
  [TYPES.IMAGE_MULTI_SELECTION]: (
    <FilterBasicDefault
      checkElementType={IMAGE}
      isFullWidth={false}
      isMultiSelect
      listDirection={LIST_DIRECTIONS.ROW}
      listItemDirection={COLUMN_REVERSE}
    />
  ),
  [TYPES.IMAGE_MULTI_SELECTION_GRID_COLUMN]: (
    <FilterBasicDefault
      checkElementType={IMAGE}
      isFullWidth={false}
      isMultiSelect
      listDesign={DESIGNS.GRID_COLUMN}
      listDirection={LIST_DIRECTIONS.ROW}
      listItemDirection={COLUMN_REVERSE}
    />
  ),
  [TYPES.IMAGE_MULTI_SELECTION_GRID_COLUMN_WITH_BORDER]: (
    <FilterBasicDefault
      checkElementType={IMAGE}
      isFullWidth={false}
      isMultiSelect
      listDesign={DESIGNS.GRID_COLUMN}
      listDirection={LIST_DIRECTIONS.ROW}
      listItemDirection={COLUMN_REVERSE}
      listItemsDesign={FLAT_OUTLINED}
    />
  ),
  [TYPES.IMAGE_MULTI_SELECTION_WITH_BORDER_ROW_SCROLLABLE]: (
    <FilterBasicDefault
      checkElementType={IMAGE}
      isFullWidth={false}
      isMultiSelect
      isScrollable
      listDirection={LIST_DIRECTIONS.ROW}
      listItemDirection={COLUMN_REVERSE}
      listItemsDesign={FLAT_OUTLINED}
    />
  ),
  [TYPES.MULTI_SELECTION_NESTED]: <FilterBasicMultiSelectionNested />,
  [TYPES.MULTI_SELECTION]: <FilterBasicDefault checkElementType={CHECKBOX} isMultiSelect />,
  [TYPES.RADIO_BUTTON_GROUP_MULTI_SELECTION]: <FilterBasicDefault checkElementType={RADIO_BUTTON} isMultiSelect />,
  [TYPES.RADIO_BUTTON_GROUP_SINGLE_SELECTION]: <FilterBasicDefault checkElementType={RADIO_BUTTON} />,
  [TYPES.SINGLE_SELECTION]: <FilterBasicDefault />,
  [TYPES.SINGLE_SELECTION_OUTLINED]: <FilterBasicDefault listItemsDesign={OUTLINED} />,
  [TYPES.MULTI_SELECTION_OUTLINED]: <FilterBasicDefault isMultiSelect listItemsDesign={OUTLINED} />,
  [TYPES.MULTI_SELECTION_ROUNDED_OUTLINED]: (
    <FilterBasicDefault
      isLeftIcon
      isMultiSelect
      listItemsDesign={ROUNDED_OUTLINED}
      listDirection={LIST_DIRECTIONS.ROW_ROUNDED}
    />
  ),
  [TYPES.MULTI_SELECTION_ROUNDED_OUTLINED_WITHOUT_ICON_CHECK]: (
    <FilterBasicDefault
      hasIconCheck={false}
      isMultiSelect
      listItemsDesign={ROUNDED_OUTLINED}
      listDirection={LIST_DIRECTIONS.ROW_ROUNDED}
    />
  )
}

export const ALL_SELECTIONS_ID = 'allSelections'

export const DEFAULT_EMPTY_SELECTIONS = []
export const DEFAULT_ALL_OPTIONS_SELECTED = [ALL_SELECTIONS_ID]

export const FORCE_FLAG = true
